<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="900px"
    custom-class="peopleDialog">
    <div class="title" slot="title">
      {{id ? '编辑宣传信息' : '新增宣传信息'}}
    </div>
      <div class="form-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="ruleFormYan">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="信息标题" ref="title" prop="title">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.title" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="信息内容" class="listcontent" ref="content" prop="content">
                <div class="flex justify-start align-center">
                  <el-input type="textarea" v-model="ruleForm.content" class="inp">
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item class="errorTips" label="上传附件" ref="file" prop="file">
                <div class="flex justify-start align-center">
                  <a :href="ruleForm.file" target="_blank" download rel="noopener" v-if="ruleForm.file"
                     class="look">查看附件</a>
                  <upload-file
                    class="upZuj"
                    name="file"
                    @uploadFile="uploadFile"
                  >
                    <div class="btnUp" slot="upload">
                      <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传附件
                    </div>
                  </upload-file>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <div class="flex justify-start align-center">
                <div class="btn-box">
                  <div class="btn" @click="submitForm('ruleForm')">确定</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
  </el-dialog>
</template>
<script>
import {imgUrl} from "@/config";
import {isYes} from "@/utils/const";
import UploadFile from "@/components/UploadFile";
import {get_promote, promote_save,} from "@/api";
export default {
  name: "peopleDialog",
  data() {
    return {
      imgUrl:imgUrl,
      isYes:isYes,
      classes:[],
      ruleForm:{
        title: '', // 信息标题
        content: '', // 信息内容
        file: '', // 上传附件
      },
      rules:{
        file: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
        content: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        title: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ''
    },
  },
  components: {UploadFile},
  created() {

  },
  methods: {
    async init(){
      let _data = await get_promote(this.id);
      if(_data.status == 200){
        this.ruleForm = {
          title: _data.data.title, // 信息标题
          content: _data.data.content, // 信息内容
          file: _data.data.files // 上传附件
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitInfo()
        }
      });
    },

    async submitInfo(){
      let _data = await promote_save(
        this.id,
        this.ruleForm.title,
        this.ruleForm.content,
        this.ruleForm.file
      );
      if(_data.status == 200){
        this.$message.success(_data.msg)
        this.handleClose()
      } else {
        this.$message.error(_data.msg)
      }
    },

    uploadFile(data) {
      this.ruleForm[data.name] = data.file.url
    },

    handleClose(){
      this.$refs.ruleForm.resetFields()
      this.$emit('handleClose',false)
    },


  },
  watch: {
    dialogVisible(){
      if(this.dialogVisible) {
        if(this.id){
          this.init()
        }
      }
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
.peopleDialog {
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #e5e5e5;
  }
  .form-content {
    width: 100%;
    .title-flex {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 20px;

      b {
        font-size: 18px;
        color: #000000;
        font-weight: bold;
        margin-right: 10px;
      }
    }


    .width {
      width: 400px;
    }

    .btn-box {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 30px 0;

      .btn {
        width: 180px;
        height: 40px;
        background-image: linear-gradient(0deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
      }
    }
    .add {
      width: 24px;
      cursor: pointer;
    }

    .inp {
      flex: 1;
    }

    .tips {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      background-color: #fef0ef;
      border-radius: 4px;
      margin-left: 10px;
      font-size: 14px;
      color: #f34336;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 16px;

      i {
        font-size: 20px;
        color: #f34336;
        margin-right: 4px;
      }
      &.short {
        width: 120px;
      }
      &.zhengm {
        width: 250px;
      }
      &.width {
        width: 350px;
      }
    }

    .look {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      border: 1px solid #2791ff;
      color: #2791ff;
      line-height: 34px;
      text-align: center;
      font-size: 14px;
      margin-left: 10px;
      border-radius: 4px;
      margin-top: 15px;
    }

    .btnUp {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      margin-left: 10px;
      background-image: linear-gradient(90deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #ffffff;

      i {
        font-size: 20px;
        color: #ffffff;
        margin-right: 5px;
        font-weight: 100;
      }
    }
  }
}
</style>


